import { useCallback, useEffect } from 'react';
import { useAtom } from 'jotai';
import {
  searchResultsAtom,
  isSearchingAtom,
  includeViewsAtom,
  DEFAULT_SEARCH_RESULT,
} from './SearchResult/trpcSearchResultState';
import { sidebarSearchKeywordAtom } from './sidebarSearchKeywordAtom';
import { trpcClient } from '@framework/trpcClient';

export const useSidebarSearch = (groupId: string) => {
  const [searchKeyword] = useAtom(sidebarSearchKeywordAtom);
  const [searchResults, setSearchResults] = useAtom(searchResultsAtom);
  const [isSearching, setIsSearching] = useAtom(isSearchingAtom);
  const [includeViews] = useAtom(includeViewsAtom);

  const executeSearch = useCallback(async () => {
    if (!searchKeyword) {
      setSearchResults(DEFAULT_SEARCH_RESULT);
      return;
    }

    setIsSearching(true);
    try {
      const res = await trpcClient.sidebar.search.search.query({
        groupId,
        searchKeyword,
        includeViews,
      });

      setSearchResults(res);
    } catch (error) {
      console.error('Search error:', error);
      setSearchResults(DEFAULT_SEARCH_RESULT);
    } finally {
      setIsSearching(false);
    }
  }, [searchKeyword, groupId, includeViews, setSearchResults, setIsSearching]);

  useEffect(() => {
    executeSearch();
  }, [executeSearch]);

  return {
    searchResults,
    isSearching,
  };
};
